export interface PageDataLayerConfig {
  pageGroupType: string;
  pageSubgroupType?: string;
}

export const PAGE_DATA_LAYER_MAP: Record<string, PageDataLayerConfig> = {
  "/": {
    pageGroupType: "Homepage"
  },
  "/why-collette": {
    pageGroupType: "Why Collette Page"
  },
  "/why-collette/travel-company-history": {
    pageGroupType: "Why Collette Page",
    pageSubgroupType: "Travel Company History Page"
  },
  "/why-collette/our-values": {
    pageGroupType: "Why Collette Page",
    pageSubgroupType: "Our Values Page"
  },
  "/why-collette/travel-awards-reviews": {
    pageGroupType: "Why Collette Page",
    pageSubgroupType: "Travel Awards and Reviews Page"
  },
  "/why-collette/sustainable-travel": {
    pageGroupType: "Why Collette Page",
    pageSubgroupType: "Sustainable Travel Page"
  },
  "/about-collette/careers": {
    pageGroupType: "About Collette Page",
    pageSubgroupType: "Careers Page"
  },
  "/find-your-tour": {
    pageGroupType: "Find Your Tour Page"
  },
  "/deals": {
    pageGroupType: "Deals Page"
  },
  "/travel-blog": {
    pageGroupType: "Travel Blog Page"
  },
  "/travel-blog/[slug]": {
    pageGroupType: "Travel Blog Page",
    pageSubgroupType: "Blog Post Page"
  },
  "/travel-blog/search": {
    pageGroupType: "Travel Blog Page",
    pageSubgroupType: "Search Page"
  },
  "/news": {
    pageGroupType: "News Page"
  },
  "/news/[slug]": {
    pageGroupType: "News Page"
  },
  "/news/search": {
    pageGroupType: "News Page",
    pageSubgroupType: "Search Page"
  },
  "/travel-styles/classic-tours": {
    pageGroupType: "Travel Styles Page",
    pageSubgroupType: "Classic Tours Page"
  },
  "/travel-styles/small-group-tours": {
    pageGroupType: "Travel Styles Page",
    pageSubgroupType: "Small Group Tours Page"
  },
  "/travel-styles/private-group-tours": {
    pageGroupType: "Travel Styles Page",
    pageSubgroupType: "Private Group Tours Page"
  },
  "/travel-styles/spotlight-tours": {
    pageGroupType: "Travel Styles Page",
    pageSubgroupType: "Spotlight Tours Page"
  },
  "/travel-styles/solo-travel-tours": {
    pageGroupType: "Travel Styles Page",
    pageSubgroupType: "Solo Travel Tours Page"
  },
  "/travel-styles/cruise-tours": {
    pageGroupType: "Travel Styles Page",
    pageSubgroupType: "Cruise Tours Page"
  },
  "/travel-styles/faith-based-travel": {
    pageGroupType: "Travel Styles Page",
    pageSubgroupType: "Faith Based Travel Page"
  },
  "/order-brochures": {
    pageGroupType: "Order Brochures Page",
    pageSubgroupType: "Logged Out"
  },
  "/travel-advisors/order-brochures": {
    pageGroupType: "Travel Advisors Order Brochures Page",
    pageSubgroupType: "Logged In"
  }
};
